export enum ShareHolderType {
    CONTROLLER = 'Controller',
    REPRESENTATIVE = 'Representative',
    SHAREHOLDER = 'Shareholder',
}
